<template>  
	   <div class="mdc-card mgt-24 pdt-24 pdb-16 pdl-24 pdr-24" v-if="listData && fillInTheBlank">
					<div class="t-color4 t-color-bodyGrayA l-spacing36 font-r t-body3">{{ $t('1958')}}</div>
			   
				<div class="single t-color-headlineBlack" >
						<!-- {{question.contents.text}} -->
						<div v-for="(node, n) in nodes" :key="n">
							<answer-type v-if="n % 2" 
								:data="fillInTheBlank.items[node]"
								:itemIndex="node"
								:setedAnswer="fillInTheBlank.items[node].reply"
								class="mgt-8 mgb-16"
							></answer-type>
							<div v-else class="mgt-8 mgb-16 font-m t-subtitle3">{{node}}</div>
						</div>
					 <!-- <div class="mgt-16 report-img-video-bd-radius" v-if="listData.question.image && listData.question.image.resourceUri">
						<img class="report-img-video-bd-radius" :src="listData.question.image.resourceUri" alt="">
					</div> -->
				<div class="mgt-16" v-if="listData.question.image && listData.question.image.resourceUri">
						<img class="round mgb-8" :src="listData.question.image.resourceUri" alt="" />
				</div>
				</div>
	</div>
</template>

<script>
/**
 * 응답내장형 문항 피드백 컴포넌트(fill in the blank type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

import {questionMixin} from '@/mixins/question.js'
//import QuestionTag from './QuestionTag.vue'
import AnswerType from '@/components/exam/question/AnswerTypeFeedback.vue'

export default {
	props: ['listData', 'fillInTheBlank'],
	data() {
		return {
			texts: '',
			parsedQuestionTitle: '',
			parsedQuestionCorrect: '',
			questionImage:null
		}
	},
	

	mixins: [questionMixin],

	components: {
		'answer-type': AnswerType,
	},

	mounted() {
		this.texts = ''
		this.parsedQuestionTitle = this.fillInTheBlank.contents
		this.parsedQuestionCorrect = this.fillInTheBlank.contents.text
	   
		let msg = this.parsedQuestionCorrect
		let patten=/\[.+?\]/g

		if(this.listData && this.listData.question && this.listData.question.image) {
			let getImage = this.listData.question.image.resourceUri.split('default_thumnail_en.jpg')
			if(getImage[1] !=''){
				this.questionImage = this.listData.question.image.resourceUri;
			} else {
				this.questionImage = null
			}
		}
		
	},

	
	computed: {
		// 응답 내장형 문항 답안 파싱(parse question answer)
		nodes() {
			return this.parsedQuestionTitle.split(/\{([0-9]+)\}/g)
		},

		// 응답 내장형 문항 정답 파싱(parse question correct)
		nodesCorrect() {
			return this.parsedQuestionCorrect.split(/\[(.*?)\]/g)
		}
	},
}
</script>